// extracted by mini-css-extract-plugin
export default {"savedCars":"Favorites_savedCars__4Nib7","title":"Favorites_title__-92pB","savesIsHavent":"Favorites_savesIsHavent__3pOiE"};